import URL_API_CASO from "@/shared/utils/ApiUrl/ApiCasos";
import { HTTP } from "../Http.service";
import type { ActualizarMultiplesPreferenciasRequest, AlertaLeidaRequest, AlertasLeidasRequest, LimpiarAlertasRequest } from "@/shared/types/interfaces/ApiCasos/Alertas.interface";

const http = HTTP(); 

/**
 * Marca un conjunto de alertas como leídas.
 */
async function AlertasLeidas(data : AlertasLeidasRequest): Promise<any> {
    return await http.Post(`${URL_API_CASO.ALERTAS_LEIDAS}`, {body: data});
}

/**
 * Marca una alerta individual como leída.
 */
async function AlertaLeida(data : AlertaLeidaRequest): Promise<any> {
    return await http.Post(`${URL_API_CASO.ALERTA_LEIDA}`, {body: data});
}

/**
 * Limpia todas las alertas de un usuario.
 */
async function LimpiarAlertas(data : LimpiarAlertasRequest): Promise<any> {
    return await http.Post(`${URL_API_CASO.LIMPIAR_ALERTAS}`, {body: data});
}

/**
 * Obtener preferencias de notificación. 
 * Recupera las preferencias de un usuario para un destinatario (Personal/Entidad).
 */
async function ObtenerPreferencias(queryString : string): Promise<any> {
    return await http.Get(`${URL_API_CASO.OBTENER_PREFERENCIAS}${queryString}`, {});
}

/**
 * Actualizar una preferencia (unitaria).
 * Actualiza el estado de notificación de una actividad específica.
 */
async function ActualizarPreferencia(data : any): Promise<any> {
    return await http.Put(`${URL_API_CASO.ACTUALIZAR_PREFERENCIA}`, {body: data});
}

/**
 * Actualizar múltiples preferencias.
 * Actualiza el estado de notificación de varias actividades a la vez.
 */
async function ActualizarMultiplesPreferencias(data : ActualizarMultiplesPreferenciasRequest): Promise<any> {
    return await http.Post(`${URL_API_CASO.ACTUALIZAR_MULTIPLES_PREFERENCIAS}`, {body: data});
}

export {
    AlertasLeidas,
    AlertaLeida,
    LimpiarAlertas,
    ObtenerPreferencias,
    ActualizarPreferencia,
    ActualizarMultiplesPreferencias
}